export interface UserDreamProfessionModel {
  id: string;
  name: string | null;
  position_id: string | null;
  order: number;
}

export interface EditUserDreamProfessionListModel {
  items: UserDreamProfessionModel[] | null;
}
